import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import { Typography } from "@mui/joy";
import {
  Button,
  Collapse,
  Divider,
  FormControlLabel,
  IconButton,
  Radio,
  RadioGroup,
  Stack,
} from "@mui/material";
import { Fragment, useEffect, useState } from "react";
import {
  GroupedArticleByLevel,
  Ingredient,
  MenuItem,
  SelectedIngredient,
  SelectionMode,
} from "../../../../../../interfaces/Catalogue";
import IngredientModal from "../Modals/IngredientModal/IngredientModal";
import "./MonoSelectionList.scss";
import {
  findPriceByTypeOrder,
  getPriceByTypeOrderForComposition,
} from "../../../../../../utils/priceUtils";

interface LevelUniSelectionProps {
  levelIndex: number;
  typeOrder: number;
  level: GroupedArticleByLevel;
  hasOneItem: boolean;
  updateSelectedArticles: (
    selecteMenuItem: MenuItem,
    selectedIngredients: SelectedIngredient[],
    eliminatedIngredients: SelectedIngredient[],
    mode: SelectionMode
  ) => void;
}

const MonoSelectionList = (props: LevelUniSelectionProps) => {
  const { levelIndex, level, typeOrder, updateSelectedArticles, hasOneItem } =
    props;
  const [checkedItem, setCheckedItem] = useState<MenuItem>();
  const [ingredientModalState, setIngredientModalState] = useState<{
    isOpen: boolean;
    activeIndex: number | null;
  }>({ isOpen: false, activeIndex: null });
  const [ingredientSelections, setIngredientSelections] = useState<
    SelectedIngredient[]
  >([]);

  const handleOpenIngredientModal = (id: number) => {
    setIngredientModalState({ isOpen: true, activeIndex: id });
  };

  const handleCloseIngredientModal = () => {
    setIngredientModalState({ isOpen: false, activeIndex: null });
  };

  useEffect(() => {
    if (
      levelIndex == 0 &&
      hasOneItem &&
      level?.menuItems &&
      !level?.menuItems[0].isOutOfStock
    ) {
      handleSelect(level?.menuItems[0]);
    }
  }, [levelIndex, hasOneItem, level]);

  const handleSelect = (menuItem: MenuItem) => {
    menuItem.quantity = 1;
    setCheckedItem(menuItem);
    // if (menuItem?.articleComposition) {

    const initialSelectedIngredients = menuItem?.articleComposition
      ?.filter((ingredient: Ingredient) => ingredient?.inclus)
      ?.map((ingredient: Ingredient) => ({
        id: ingredient?.id,
        ingredient,
        quantity: 1,
      }));

    setIngredientSelections(initialSelectedIngredients);
    // }
    updateSelectedArticles(
      menuItem,
      initialSelectedIngredients || [],
      [],
      SelectionMode.SINGLE
    );
  };

  const updateIngredientSelections = (
    selections: SelectedIngredient[],
    eliminatedIngredients: SelectedIngredient[],
    menuItem: MenuItem
  ) => {
    menuItem.quantity = 1;
    setCheckedItem(menuItem);
    setIngredientSelections(selections);
    updateSelectedArticles(
      menuItem,
      selections,
      eliminatedIngredients,
      SelectionMode.SINGLE
    );
  };

  return (
    <RadioGroup value={level?.name}>
      {level?.menuItems?.map((menuItem: MenuItem, index: number) => {
        const price =
          findPriceByTypeOrder(menuItem?.typeOrderPrices, typeOrder) || 0;

        const remiseMessage =
          menuItem.rewardDiscountType === 0
            ? `${menuItem.rewardDiscountValue}%`
            : `${menuItem.rewardDiscountValue?.toFixed(2)} €`;

        const message = `${remiseMessage} offerts pour ${menuItem.rewardTotalPtRequired} points`;
        const purchaseOffersMessage = ` ${menuItem.purchaseOffers?.nbPurchased} acheté(s) = ${menuItem.purchaseOffers?.nbOffered} offert(s)`;

        const hasRewardDiscount = !!menuItem.rewardDiscountValue;
        const hasPurchaseOffers = !!menuItem.purchaseOffers;

        const combinedMessage = `🎁 ${
          hasRewardDiscount ? message : ""
        }${hasRewardDiscount && hasPurchaseOffers ? " / " : ""}${
          // }${hasRewardDiscount && hasPurchaseOffers ? " • / " : ""}${
          hasPurchaseOffers ? purchaseOffersMessage : ""
        }`;

        return (
          <div>
            <Fragment>
              <div
                className="componentContainer column"
                style={{ alignItems: "center" }}
              >
                <div
                  className="componentRow full-width"
                  style={{ paddingRight: 12 }}
                >
                  <FormControlLabel
                    value={menuItem?.name}
                    checked={menuItem?.id == checkedItem?.id}
                    control={
                      menuItem.isOutOfStock ? (
                        <span className="epuise epuise-radio">Épuisé</span>
                      ) : (
                        <Radio
                          className={`radioIcon ${menuItem.isOutOfStock ? "disabledRadio" : ""}`}
                          size="small"
                          disabled={menuItem.isOutOfStock}
                        />
                      )
                    }
                    label={
                      <div>
                        <Typography
                          style={{
                            fontFamily: "Poppins,sans-serif",
                            fontSize: "12px",
                            fontWeight: 600,
                            color: `${menuItem.isOutOfStock ? "#999999" : "#1D2939"}`,
                          }}
                        >
                          {menuItem.name.toLowerCase()}
                        </Typography>
                        {(hasRewardDiscount || hasPurchaseOffers) && (
                          <p className="loyaltyMessage">{combinedMessage} </p>
                        )}
                        {/* {menuItem.purchaseOffers && (
                          <p className="loyaltyMessage">
                            {purchaseOffersMessage}
                          </p>
                        )}*/}
                        {menuItem.typeOrderPrices ? (
                          <Typography
                            style={{
                              fontSize: "12px",
                              fontWeight: 500,
                              color: "#475467",
                            }}
                          >
                            {price > 0 && `+${price} €`}
                          </Typography>
                        ) : null}
                      </div>
                    }
                    labelPlacement="start"
                    className=""
                    style={{
                      justifyContent: "space-between",
                      flex: 1,
                    }}
                    onChange={(e: any) => {
                      handleSelect(menuItem);
                    }}
                  />

                  {menuItem?.nbrComposition > 0 && (
                    <IconButton
                      onClick={() => {
                        !menuItem.isOutOfStock &&
                          handleOpenIngredientModal(menuItem.id);
                      }}
                    >
                      <div
                        className={`btnArrow ${menuItem.isOutOfStock ? "outOfStock" : ""}`}
                      >
                        <ChevronRightRoundedIcon />
                      </div>
                    </IconButton>
                  )}
                </div>

                {menuItem?.nbrComposition > 0 &&
                  ingredientSelections?.length > 0 && (
                    <Collapse
                      in={checkedItem?.id === menuItem?.id}
                      className="all-center tableComposition"
                      style={{ width: "70%" }}
                    >
                      <Stack
                        className="compositionPreview full-width"
                        spacing={0.5}
                        direction={"column"}
                      >
                        <Stack direction={"column"} spacing={0.7}>
                          {ingredientSelections?.map(
                            (
                              selectedIngredient: SelectedIngredient,
                              i: number
                            ) => {
                              const { ingredient, quantity } =
                                selectedIngredient;

                              const price = getPriceByTypeOrderForComposition(
                                typeOrder,
                                ingredient
                              );
                              return (
                                <p key={i} className="row tableItem">
                                  {quantity > 1 && quantity}{" "}
                                  {ingredient?.name.toLowerCase()}{" "}
                                  {price > 0 && ` +${price} €`}
                                </p>
                              );
                            }
                          )}
                        </Stack>

                        <Divider />
                        <Button
                          onClick={() => {
                            handleOpenIngredientModal(menuItem?.id);
                          }}
                          variant="text"
                          size="small"
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <small style={{ color: "#344054" }}>
                            Modifier votre sélection{" "}
                          </small>
                          <ChevronRightRoundedIcon
                            style={{ fill: "#344054" }}
                          />
                        </Button>
                      </Stack>
                    </Collapse>
                  )}
              </div>
            </Fragment>

            {ingredientModalState?.isOpen &&
              ingredientModalState?.activeIndex === menuItem?.id && (
                <IngredientModal
                  isOpen={ingredientModalState?.isOpen}
                  onClose={handleCloseIngredientModal}
                  updateIngredientSelections={updateIngredientSelections}
                  menuItem={menuItem}
                  compositionMaxSelection={menuItem?.compositionMaxSelection}
                  ingredients={menuItem?.articleComposition}
                  typeOrder={typeOrder}
                  ingredientSelections={ingredientSelections}
                  isCheckedItem={checkedItem?.id === menuItem?.id}
                />
              )}
          </div>
        );
      })}
    </RadioGroup>
  );
};

export default MonoSelectionList;
